<template>
    <IntegrationSettingsCard icon="fas fa-cogs"
                             title="API Settings"
                             description="Manage general settings for the integration"
    >
        <template v-slot:body>
            <form>
                <div class="row">
                    <div class="col-md-6">
                        <FormGroupNew label="API User"
                                      description="Enter the username for the API."
                                      :error="configs.errors.mauve_api_user"
                                      :required="requiredFields.includes('mauve_api_user')">
                            <input type="text" autocomplete="false" class="form-control"
                                   v-model="configs.mauve_api_user">
                        </FormGroupNew>
                    </div>
                    <div class="col-md-6">
                        <FormGroupNew label="API Password"
                                      description="Enter the users password."
                                      :error="configs.errors.mauve_api_pw"
                                      :required="requiredFields.includes('mauve_api_pw')">
                            <PasswordInput v-model="configs.mauve_api_pw" />
                        </FormGroupNew>
                    </div>
                </div>
            </form>

            <MauveApiTest :configs="configs" />
        </template>

        <template v-slot:footer>
            <SaveAndEnableButton :show-enable-variant="integration.state === 'missing_config'"
                                 :disabled="!configs.isDirty"
                                 @click="saveUserSettings"/>
        </template>
    </IntegrationSettingsCard>
</template>

<script>
import IntegrationsSettingsLayout from "@layouts/IntegrationsSettingsLayout.vue";
import IntegrationSettingsCard from "@components/Integrations/IntegrationSettingsCard.vue";
import Spinner from "vue-simple-spinner";
import SaveAndEnableButton from "@components/Integrations/SaveAndEnableButton.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import MauveApiTest from "@components/Integrations/Mauve/MauveApiTest.vue";
import PasswordInput from "@components/Form/PasswordInput.vue";

export default {
    components: {PasswordInput, MauveApiTest, FormGroupNew, SaveAndEnableButton, IntegrationSettingsCard, Spinner},

    layout: IntegrationsSettingsLayout,

    props: {
        integration: Object,
        formData: Object,
        stores: Array,
        enabledStores: Array,
        requiredFields: Array
    },

    data() {
        return {
            configs: this.$inertia.form(this.formData),
        }
    },

    methods: {
        saveUserSettings() {
            this.configs.post(this.$route('integration.config', this.integration.code))
        },
    }
}
</script>
